import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import PDFTitle from '@/components/ReportPDF/PDFTitle'

const Chapter3Sub1Page = ({ reportData, setPage }) => {
  const { reprotDao, phishType, secondaryCompanyNickname } = reportData || {}
  const { companyName, sendTotalCount, userCount } = reprotDao || {}
  const service = phishType
  const sendCount = userCount > 0 ? sendTotalCount / userCount : 0

  return (
    <PDFPage hideTitleDivider reportData={reportData}>
      <PDFTitle hideDivider>3.3 測試規範</PDFTitle>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_3: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}
          社交工程郵件檢測，是透過電子郵件的方式提供受測單位瞭解社交工程的存在，並提高警覺性；同時受測單位可以根據測試結果瞭解可能發生安全缺口，藉以實施其內部教育訓練來補強，並作為資訊安全的管理依據。
        </PDFParagraph>

        <PDFParagraph style={{ marginTop: 10, marginBottom: 10 }}>
          {'    '}本專案服務測試規範：
        </PDFParagraph>

        <PDFParagraph>
          <Text>• </Text>各帳號每次進行
          <Text style={{ fontWeight: 'bold' }}>{sendCount || 0}</Text>
          封社交工程郵件演練，採用可編輯文檔進行測試。
        </PDFParagraph>

        <PDFParagraph>
          <Text>• </Text>
          檢測的時間排程由客戶端決定，每帳號
          <Text style={{ fontWeight: 'bold' }}>{sendCount || 0}</Text>
          封的測試<Text>{service}</Text>可在
          <Text style={{ fontWeight: 'bold' }}>客戶指定的時間範圍內分次不定期寄送</Text>
          ，以達
          <Text>到最佳測試效果。</Text>
        </PDFParagraph>

        <PDFParagraph>
          依專案要求，
          <Text>{secondaryCompanyNickname}</Text>對<Text>{companyName}</Text>
          執行社交工程的資訊安全評估。此項測試目的是辨識出
          <Text>{companyName}</Text>
          的社交工程攻擊資安問題，以及此惡意攻擊會造成受測單位之實際影響。
        </PDFParagraph>

        <PDFParagraph>
          此分析的目標是模擬駭客對
          <Text>{companyName}</Text>
          進行社交工程的惡意<Text>{service}</Text>
          攻擊，發現脆弱的環節和對警覺性低的受測對象提供相關建議。此分文件深入地討論所有可被駭客可能進行的社交工程
          <Text>{service}</Text>
          攻擊，以及各項結果分析與建議解決方式。如果正確地遵照「建議解決方式」來改善，則可最大幅度降低社交工程攻擊所帶來的威脅與傷害。
        </PDFParagraph>
      </View>

      <PDFTitle hideDivider>3.4 執行標的</PDFTitle>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_4: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}
          <Text>{secondaryCompanyNickname}</Text>
          此次著重於測試
          <Text>{companyName}</Text>
          的整體工作同仁對於惡意<Text>{service}</Text>
          之警覺性，以降低社交工程攻擊風險。這是一個兼具全面性、整體性的社交工程測試；然而，為不危及系統之正常運作，
          <Text>{secondaryCompanyNickname}</Text>
          不做影響正常辦公作業之破壞性測試及可能造成惡意攻擊之測試。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}
          本次社交工程郵件演練服務，
          <Text>{companyName}</Text>
          所測試之標的為委託單位所指定受測單位及受測對象，並依照委託單位要求進行完整社交工程
          <Text>{service}</Text>演練。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}
          測試結果用來評估
          <Text>{companyName}</Text>
          的受測對象對於惡意郵件及釣魚郵件的警覺性，藉以強化工作同仁的資安意識，並檢驗機關宣導社交工程之防制成效。
        </PDFParagraph>
      </View>
    </PDFPage>
  )
}

export default Chapter3Sub1Page
